import { useCallback, useEffect, useState } from 'react';
import { getWorkAssignmentsByJobId } from 'wisestep-api';

import { IWorkAssignments } from '../../../features/jobs/assign/types';

const useGetWorkAssignmentInfo = (jobId: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [workAssignmentInfo, setWorkAssignmentInfo] = useState<IWorkAssignments | null>(null);

  const loadWorkAssignmentInfo = useCallback(async () => {
    if (!jobId) return;
    setLoading(true);

    try {
      const response = await getWorkAssignmentsByJobId(jobId);
      setWorkAssignmentInfo(response?.data ?? null);
    } catch (err) {
      setWorkAssignmentInfo(null);
    } finally {
      setLoading(false);
    }
  }, [jobId]);

  useEffect(() => {
    loadWorkAssignmentInfo();
  }, [loadWorkAssignmentInfo]);
  return { workAssignmentInfo, loadWorkAssignmentInfo, loading };
};

export default useGetWorkAssignmentInfo;
